import { Color, Spacing } from '@persona-id/design-tokens';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import GraphPreview from 'dashboard/components/GraphCollapsedGroupHoverCard/GraphCollapsedGroupPreview';
import { useGraphExplorer } from 'dashboard/components/GraphModule/hooks/useGraphExplorer';
import { CollapsedGroup, CollapsedGroupPreviewData } from 'dashboard/models/graph';
import { Label } from 'design-system/components/Text';

const ContentBody = styled('div')`
  min-width: 240px;
  overflow: auto;
  padding: ${Spacing[4]};
`;

const GraphContainer = styled('div')`
  margin-top: ${Spacing[2]};
  border: 1px solid ${Color.CoreSlate300};
  border-radius: ${Spacing[2]};
`;

interface CollapsedGroupHoverCardProps {
  collapsedGroup: CollapsedGroup;
}

const CollapsedGroupHoverCard = ({ collapsedGroup }: CollapsedGroupHoverCardProps) => {
  const [graphData, setGraphData] = useState<CollapsedGroupPreviewData | null>(null);
  const { graphExplorer } = useGraphExplorer();

  useEffect(() => {
    if (!collapsedGroup || !graphExplorer) {
      return;
    }
    const graphData = graphExplorer.exportCollapsedGroupPreviewData(collapsedGroup);
    setGraphData(graphData);
  }, [collapsedGroup, graphExplorer]);

  const height = 200;
  const width = 400;

  return (
    graphData && (
      <div>
        <ContentBody>
          <Label size='lg' weight='bold'>
            COLLAPSED NODES
          </Label>
          <GraphContainer>
            <GraphPreview data={graphData} height={height} width={width} />
          </GraphContainer>
        </ContentBody>
      </div>
    )
  );
};

export default CollapsedGroupHoverCard;
